module.exports = __webpack_public_path__ + "assets/img/bf.350c4f88.jpg";